import { Search } from 'utils/LiquidSyntaxToTwig';

export const GET_SEARCH_RESULT_PLACEHOLDER = (): Search => {
  return {
    default_sort_by: 'relevance',
    filters: [],
    performed: true,
    results: [
      {
        object_type: 'product',
        id: 8140612305216,
        gift_card: true,
        price: 99900,
        title: 'Sunglasses',
        url: '/products/straw-hat-with-grosgrain-band-1',
        vendor: 'Veda Store',
        handle: 'straw-hat-with-grosgrain-band-1',
        available: true,
        compare_at_price: 10000,
        compare_at_price_max: 10000,
        compare_at_price_min: 10000,
        compare_at_price_varies: false,
        content:
          '<div class="row">\n<div class="col-md-7">\n<h3>Aliquam erat & <br> volutpat porttitor</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n</div>\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/prsugnoldo.png?v=1673422633&width=500"></div>\n<div class="col-xs-12">\n<br>\n<h3>Maecenas in orci sollicitudin</h3>\n<p>Praesent euismod eu quam at pretium. Aenean vestibulum malesuada magna a blandit. Maecenas vitae congue mi. Vestibulum placerat, velit vitae eleifend efficitur, eros dolor pulvinar nibh, sed faucibus neque libero vitae purus. Praesent tincidunt nibh vitae neque congue, vulputate tincidunt velit efficitur. Cras tempor, erat in ornare pharetra, purus metus scelerisque ipsum, a sollicitudin urna velit in arcu. Nulla non nunc congue ante euismod hendrerit. Donec eu tellus eu sem vulputate scelerisque nec ut ligula. Maecenas in orci sollicitudin, suscipit enim eu, dictum turpis. Sed congue est semper ligula posuere, quis fermentum lectus lobortis. Etiam quam elit, vehicula vitae orci ac, aliquam venenatis orci. Ut accumsan tincidunt luctus.</p>\n<br>\n</div>\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/eightmarchconceptbeigebackgroundspacetext_18519372839-shcqtsdeqz.jpg?v=1673349941&width=500"></div>\n<div class="col-md-7">\n<h3>Donec eu tellus eu sem vulputate</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n</div>',
        description:
          '<div class="row">\n<div class="col-md-7">\n<h3>Aliquam erat & <br> volutpat porttitor</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/prsugnoldo.png?v=1673422633&width=500"></div>\n<div class="col-xs-12">\n<br>\n<h3>Maecenas in orci sollicitudin</h3>\n<p>Praesent euismod eu quam at pretium. Aenean vestibulum malesuada magna a blandit. Maecenas vitae congue mi. Vestibulum placerat, velit vitae eleifend efficitur, eros dolor pulvinar nibh, sed faucibus neque libero vitae purus. Praesent tincidunt nibh vitae neque congue, vulputate tincidunt velit efficitur. Cras tempor, erat in ornare pharetra, purus metus scelerisque ipsum, a sollicitudin urna velit in arcu. Nulla non nunc congue ante euismod hendrerit. Donec eu tellus eu sem vulputate scelerisque nec ut ligula. Maecenas in orci sollicitudin, suscipit enim eu, dictum turpis. Sed congue est semper ligula posuere, quis fermentum lectus lobortis. Etiam quam elit, vehicula vitae orci ac, aliquam venenatis orci. Ut accumsan tincidunt luctus.</p>\n<br>\n</div>\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/eightmarchconceptbeigebackgroundspacetext_18519372839-shcqtsdeqz.jpg?v=1673349941&width=500"></div>\n<div class="col-md-7">\n<h3>Donec eu tellus eu sem vulputate</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n</div>',
        images: [
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497419354432,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497419387200,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3a.jpg?v=1675938918',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3a.jpg?v=1675938918',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3a.jpg?v=1675938918',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.7807808,
            id: 40497419419968,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3c.png?v=1675938918',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3c.png?v=1675938918',
            width: 1300,
            height: 1665,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3c.png?v=1675938918',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.7807808,
            id: 40497419452736,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3d.png?v=1675938918',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3d.png?v=1675938918',
            width: 1300,
            height: 1665,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3d.png?v=1675938918',
            attached_to_variant: false,
          },
        ],
        featured_image: {
          created_at: 'Fri Mar 10 10:09:07 UTC 2023',
          updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
          aspect_ratio: 0.8,
          id: 40497419354432,
          media_type: 'image',
          preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
          src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
          width: 1300,
          height: 1625,
          url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
          attached_to_variant: false,
        },
        media: [
          {
            alt: '',
            id: 32852889436480,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852889436480,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852889469248,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852889469248,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3a.jpg?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3a.jpg?v=1675938918',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3a.jpg?v=1675938918',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852889502016,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.7807808,
              id: 32852889502016,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3c.png?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3c.png?v=1675938918',
              width: 1300,
              height: 1665,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3c.png?v=1675938918',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852889534784,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.7807808,
              id: 32852889534784,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3d.png?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3d.png?v=1675938918',
              width: 1300,
              height: 1665,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3d.png?v=1675938918',
              alt: '',
              attached_to_variant: false,
            },
          },
        ],
        options: ['Color', 'Size'],
        price_max: 99900,
        price_min: 99900,
        price_varies: false,
        published_at: '2023-02-09T10:35:13Z',
        created_at: '2023-02-09T10:35:18Z',
        type: 'T-Shirt',
        tags: ['Bags'],
        variants: [
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497419354432,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              attached_to_variant: false,
              variant_ids: ['44417613889856'],
            },
            barcode: '',
            compare_at_price: 10000,
            id: 44417613889856,
            inventory_management: 'NOT_MANAGED',
            options: ['Black', 'M'],
            price: 99900,
            requires_shipping: true,
            sku: 'Rev_140',
            title: 'Black / M',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497419354432,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              attached_to_variant: false,
              variant_ids: ['44417613889856'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497419354432,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              attached_to_variant: false,
              variant_ids: ['44417613922624'],
            },
            barcode: '',
            compare_at_price: 10000,
            id: 44417613922624,
            inventory_management: 'NOT_MANAGED',
            options: ['Red', 'L'],
            price: 99900,
            requires_shipping: true,
            sku: 'Rev_141',
            title: 'Red / L',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497419354432,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              attached_to_variant: false,
              variant_ids: ['44417613922624'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497419354432,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              attached_to_variant: false,
              variant_ids: ['44417613955392'],
            },
            barcode: '',
            compare_at_price: 10000,
            id: 44417613955392,
            inventory_management: 'NOT_MANAGED',
            options: ['White', 'S'],
            price: 99900,
            requires_shipping: true,
            sku: '',
            title: 'White / S',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497419354432,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              attached_to_variant: false,
              variant_ids: ['44417613955392'],
            },
            inventory_quantity: 0,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497419354432,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              attached_to_variant: false,
              variant_ids: ['44417613988160'],
            },
            barcode: '',
            compare_at_price: 10000,
            id: 44417613988160,
            inventory_management: 'NOT_MANAGED',
            options: ['Blue Violet', 'XS'],
            price: 99900,
            requires_shipping: true,
            sku: '',
            title: 'Blue Violet / XS',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497419354432,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
              attached_to_variant: false,
              variant_ids: ['44417613988160'],
            },
            inventory_quantity: 0,
          },
        ],
        options_with_values: [
          {
            name: 'Color',
            position: 1,
            values: ['Black', 'Red', 'White', 'Blue Violet'],
            selected_value: 'Black',
          },
          {
            name: 'Size',
            position: 2,
            values: ['M', 'L', 'S', 'XS'],
            selected_value: 'M',
          },
        ],
        first_available_variant: {
          image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497419354432,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            attached_to_variant: false,
            variant_ids: ['44417613889856'],
          },
          barcode: '',
          compare_at_price: 10000,
          id: 44417613889856,
          inventory_management: 'NOT_MANAGED',
          options: ['Black', 'M'],
          price: 99900,
          requires_shipping: true,
          sku: 'Rev_140',
          title: 'Black / M',
          weight: 0,
          available: true,
          featured_image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497419354432,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            attached_to_variant: false,
            variant_ids: ['44417613889856'],
          },
          inventory_quantity: 1,
        },
        selected_or_first_available_variant: {
          image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: null,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            attached_to_variant: false,
            variant_ids: ['44417613889856'],
          },
          barcode: '',
          compare_at_price: 10000,
          id: 44417613889856,
          inventory_management: 'NOT_MANAGED',
          options: ['Black', 'M'],
          price: 99900,
          requires_shipping: true,
          sku: 'Rev_140',
          title: 'Black / M',
          weight: 0,
          available: true,
          featured_image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497419354432,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            attached_to_variant: false,
            variant_ids: ['44417613889856'],
          },
          inventory_quantity: 1,
        },
        featured_media: {
          alt: '',
          id: 32852889436480,
          position: 'IMAGE',
          preview_image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 32852889436480,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-3_9b40e338-6318-4f50-8f5b-0a2702addc8e.jpg?v=1675938918',
            alt: '',
            attached_to_variant: false,
          },
        },
        has_only_default_variant: false,
        collections: [],
        selected_variant: null,
      },
      {
        object_type: 'product',
        id: 8140611027264,
        gift_card: true,
        price: 2599,
        title: 'Textured weave shirt',
        url: '/products/textured-weave-shirt',
        vendor: 'Soleed',
        handle: 'textured-weave-shirt',
        available: true,
        compare_at_price: 4599,
        compare_at_price_max: 4599,
        compare_at_price_min: 4599,
        compare_at_price_varies: false,
        content:
          '<div class="row">\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/cesimuvwzt.jpg?v=1673582225&width=500"></div>\n<div class="col-md-7">\n<h3>Aliquam erat & <br> volutpat porttitor</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n<div class="col-xs-12">\n<br>\n<h3>Maecenas in orci sollicitudin</h3>\n<p>Praesent euismod eu quam at pretium. Aenean vestibulum malesuada magna a blandit. Maecenas vitae congue mi. Vestibulum placerat, velit vitae eleifend efficitur, eros dolor pulvinar nibh, sed faucibus neque libero vitae purus. Praesent tincidunt nibh vitae neque congue, vulputate tincidunt velit efficitur. Cras tempor, erat in ornare pharetra, purus metus scelerisque ipsum, a sollicitudin urna velit in arcu. Nulla non nunc congue ante euismod hendrerit. Donec eu tellus eu sem vulputate scelerisque nec ut ligula. Maecenas in orci sollicitudin, suscipit enim eu, dictum turpis. Sed congue est semper ligula posuere, quis fermentum lectus lobortis. Etiam quam elit, vehicula vitae orci ac, aliquam venenatis orci. Ut accumsan tincidunt luctus.</p>\n<br>\n</div>\n<div class="col-md-7">\n<h3>Donec eu tellus eu sem vulputate</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/asojvfsedf.png?v=1673948044&width=500"></div>\n</div>',
        description:
          '<div class="row">\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/cesimuvwzt.jpg?v=1673582225&width=500"></div>\n<div class="col-md-7">\n<h3>Aliquam erat & <br> volutpat porttitor</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n<div class="col-xs-12">\n<br>\n<h3>Maecenas in orci sollicitudin</h3>\n<p>Praesent euismod eu quam at pretium. Aenean vestibulum malesuada magna a blandit. Maecenas vitae congue mi. Vestibulum placerat, velit vitae eleifend efficitur, eros dolor pulvinar nibh, sed faucibus neque libero vitae purus. Praesent tincidunt nibh vitae neque congue, vulputate tincidunt velit efficitur. Cras tempor, erat in ornare pharetra, purus metus scelerisque ipsum, a sollicitudin urna velit in arcu. Nulla non nunc congue ante euismod hendrerit. Donec eu tellus eu sem vulputate scelerisque nec ut ligula. Maecenas in orci sollicitudin, suscipit enim eu, dictum turpis. Sed congue est semper ligula posuere, quis fermentum lectus lobortis. Etiam quam elit, vehicula vitae orci ac, aliquam venenatis orci. Ut accumsan tincidunt luctus.</p>\n<br>\n</div>\n<div class="col-md-7">\n<h3>Donec eu tellus eu sem vulputate</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/asojvfsedf.png?v=1673948044&width=500"></div>\n</div>',
        images: [
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497412309312,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497412342080,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2_87462325-f4b5-49ad-b61d-a494c9835fdb.jpg?v=1675938856',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2_87462325-f4b5-49ad-b61d-a494c9835fdb.jpg?v=1675938856',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2_87462325-f4b5-49ad-b61d-a494c9835fdb.jpg?v=1675938856',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497412374848,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2a_e55968d0-2f3a-4218-a2fc-747e4e6e8f75.jpg?v=1675938856',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2a_e55968d0-2f3a-4218-a2fc-747e4e6e8f75.jpg?v=1675938856',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2a_e55968d0-2f3a-4218-a2fc-747e4e6e8f75.jpg?v=1675938856',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497412407616,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2b_b7ea1382-3a13-480b-bce0-803d9ba0e5f6.jpg?v=1675938856',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2b_b7ea1382-3a13-480b-bce0-803d9ba0e5f6.jpg?v=1675938856',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2b_b7ea1382-3a13-480b-bce0-803d9ba0e5f6.jpg?v=1675938856',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497412440384,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2c_bb1f4dd9-abf4-44bd-88fb-ae83a43f256d.jpg?v=1675938856',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2c_bb1f4dd9-abf4-44bd-88fb-ae83a43f256d.jpg?v=1675938856',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2c_bb1f4dd9-abf4-44bd-88fb-ae83a43f256d.jpg?v=1675938856',
            attached_to_variant: false,
          },
        ],
        featured_image: {
          created_at: 'Fri Mar 10 10:09:07 UTC 2023',
          updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
          aspect_ratio: 0.8,
          id: 40497412309312,
          media_type: 'image',
          preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
          src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
          width: 1300,
          height: 1625,
          url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
          attached_to_variant: false,
        },
        media: [
          {
            alt: '',
            id: 32852882227520,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852882227520,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852882260288,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852882260288,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2_87462325-f4b5-49ad-b61d-a494c9835fdb.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2_87462325-f4b5-49ad-b61d-a494c9835fdb.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2_87462325-f4b5-49ad-b61d-a494c9835fdb.jpg?v=1675938856',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852882293056,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852882293056,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2a_e55968d0-2f3a-4218-a2fc-747e4e6e8f75.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2a_e55968d0-2f3a-4218-a2fc-747e4e6e8f75.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2a_e55968d0-2f3a-4218-a2fc-747e4e6e8f75.jpg?v=1675938856',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852882325824,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852882325824,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2b_b7ea1382-3a13-480b-bce0-803d9ba0e5f6.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2b_b7ea1382-3a13-480b-bce0-803d9ba0e5f6.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2b_b7ea1382-3a13-480b-bce0-803d9ba0e5f6.jpg?v=1675938856',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852882358592,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852882358592,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2c_bb1f4dd9-abf4-44bd-88fb-ae83a43f256d.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2c_bb1f4dd9-abf4-44bd-88fb-ae83a43f256d.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2c_bb1f4dd9-abf4-44bd-88fb-ae83a43f256d.jpg?v=1675938856',
              alt: '',
              attached_to_variant: false,
            },
          },
        ],
        options: ['Color', 'Size'],
        price_max: 2599,
        price_min: 2599,
        price_varies: false,
        published_at: '2023-02-09T10:34:06Z',
        created_at: '2023-02-09T10:34:16Z',
        type: 'T-Shirt',
        tags: ['Sunglasses'],
        variants: [
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609695552'],
            },
            barcode: '',
            compare_at_price: 4599,
            id: 44417609695552,
            inventory_management: 'NOT_MANAGED',
            options: ['Lemon Chiffon', 'XL'],
            price: 2599,
            requires_shipping: true,
            sku: 'Rev_153',
            title: 'Lemon Chiffon / XL',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609695552'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609728320'],
            },
            barcode: '',
            compare_at_price: 4599,
            id: 44417609728320,
            inventory_management: 'NOT_MANAGED',
            options: ['Blue', 'XS'],
            price: 2599,
            requires_shipping: true,
            sku: '',
            title: 'Blue / XS',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609728320'],
            },
            inventory_quantity: 0,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609761088'],
            },
            barcode: '',
            compare_at_price: 4599,
            id: 44417609761088,
            inventory_management: 'NOT_MANAGED',
            options: ['Chartreuse', 'XL'],
            price: 2599,
            requires_shipping: true,
            sku: '',
            title: 'Chartreuse / XL',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609761088'],
            },
            inventory_quantity: 0,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609793856'],
            },
            barcode: '',
            compare_at_price: 4599,
            id: 44417609793856,
            inventory_management: 'NOT_MANAGED',
            options: ['Cadet Blue', 'XS'],
            price: 2599,
            requires_shipping: true,
            sku: '',
            title: 'Cadet Blue / XS',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609793856'],
            },
            inventory_quantity: 0,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609826624'],
            },
            barcode: '',
            compare_at_price: 4599,
            id: 44417609826624,
            inventory_management: 'NOT_MANAGED',
            options: ['Silver', 'XL'],
            price: 2599,
            requires_shipping: true,
            sku: '',
            title: 'Silver / XL',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609826624'],
            },
            inventory_quantity: 0,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609859392'],
            },
            barcode: '',
            compare_at_price: 4599,
            id: 44417609859392,
            inventory_management: 'NOT_MANAGED',
            options: ['Green', 'XL'],
            price: 2599,
            requires_shipping: true,
            sku: '',
            title: 'Green / XL',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497412309312,
              media_type: 'image',
              preview_image:
                'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
              attached_to_variant: false,
              variant_ids: ['44417609859392'],
            },
            inventory_quantity: 0,
          },
        ],
        options_with_values: [
          {
            name: 'Color',
            position: 1,
            values: ['Lemon Chiffon', 'Blue', 'Chartreuse', 'Cadet Blue', 'Silver', 'Green'],
            selected_value: 'Lemon Chiffon',
          },
          {
            name: 'Size',
            position: 2,
            values: ['XL', 'XS'],
            selected_value: 'XL',
          },
        ],
        first_available_variant: {
          image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497412309312,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            attached_to_variant: false,
            variant_ids: ['44417609695552'],
          },
          barcode: '',
          compare_at_price: 4599,
          id: 44417609695552,
          inventory_management: 'NOT_MANAGED',
          options: ['Lemon Chiffon', 'XL'],
          price: 2599,
          requires_shipping: true,
          sku: 'Rev_153',
          title: 'Lemon Chiffon / XL',
          weight: 0,
          available: true,
          featured_image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497412309312,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            attached_to_variant: false,
            variant_ids: ['44417609695552'],
          },
          inventory_quantity: 1,
        },
        selected_or_first_available_variant: {
          image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: null,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            attached_to_variant: false,
            variant_ids: ['44417609695552'],
          },
          barcode: '',
          compare_at_price: 4599,
          id: 44417609695552,
          inventory_management: 'NOT_MANAGED',
          options: ['Lemon Chiffon', 'XL'],
          price: 2599,
          requires_shipping: true,
          sku: 'Rev_153',
          title: 'Lemon Chiffon / XL',
          weight: 0,
          available: true,
          featured_image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497412309312,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            attached_to_variant: false,
            variant_ids: ['44417609695552'],
          },
          inventory_quantity: 1,
        },
        featured_media: {
          alt: '',
          id: 32852882227520,
          position: 'IMAGE',
          preview_image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 32852882227520,
            media_type: 'image',
            preview_image:
              'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-2d_aaf3b7f8-580a-4d63-8a4d-70a39e84b9ee.jpg?v=1675938856',
            alt: '',
            attached_to_variant: false,
          },
        },
        has_only_default_variant: false,
        collections: [],
        selected_variant: null,
      },
      {
        object_type: 'product',
        id: 8140610601280,
        gift_card: true,
        price: 999,
        title: 'Crossed top with straps',
        url: '/products/crossed-top-with-straps',
        vendor: 'Myshopkit',
        handle: 'crossed-top-with-straps',
        available: true,
        compare_at_price: 2999,
        compare_at_price_max: 2999,
        compare_at_price_min: 2999,
        compare_at_price_varies: false,
        content:
          '<div class="row">\n<div class="col-xs-12">\n<br>\n  <h3>Maecenas in orci sollicitudin</h3>\n  <p>Praesent euismod eu quam at pretium. Aenean vestibulum malesuada magna a blandit. Maecenas vitae congue mi.\n    Vestibulum placerat, velit vitae eleifend efficitur, eros dolor pulvinar nibh, sed faucibus neque libero vitae\n    purus. Praesent tincidunt nibh vitae neque congue, vulputate tincidunt velit efficitur. Cras tempor, erat in\n    ornare pharetra, purus metus scelerisque ipsum, a sollicitudin urna velit in arcu. Nulla non nunc congue ante\n    euismod hendrerit. Donec eu tellus eu sem vulputate scelerisque nec ut ligula. Maecenas in orci sollicitudin,\n    suscipit enim eu, dictum turpis. Sed congue est semper ligula posuere, quis fermentum lectus lobortis. Etiam quam\n    elit, vehicula vitae orci ac, aliquam venenatis orci. Ut accumsan tincidunt luctus.</p>\n  <br>\n</div>\n<div class="col-md-4"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/iqnybdlsju.webp?v=1673517351&width=700"></div>\n<div class="col-md-8">\n<h3>Aliquam erat & <br> volutpat porttitor</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia\n  nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat\n  mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat\n  facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis\n  scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum\n  pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida,\n  at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut\n  ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis\n  molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n<br>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia\n    nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat\n    mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat\n    facilisis. Proin nec consectetur enim.</p>\n</div>\n</div>',
        description:
          '<div class="row">\n<div class="col-xs-12">\n<br>\n  <h3>Maecenas in orci sollicitudin</h3>\n  <p>Praesent euismod eu quam at pretium. Aenean vestibulum malesuada magna a blandit. Maecenas vitae congue mi.\n    Vestibulum placerat, velit vitae eleifend efficitur, eros dolor pulvinar nibh, sed faucibus neque libero vitae\n    purus. Praesent tincidunt nibh vitae neque congue, vulputate tincidunt velit efficitur. Cras tempor, erat in\n    ornare pharetra, purus metus scelerisque ipsum, a sollicitudin urna velit in arcu. Nulla non nunc congue ante\n    euismod hendrerit. Donec eu tellus eu sem vulputate scelerisque nec ut ligula. Maecenas in orci sollicitudin,\n    suscipit enim eu, dictum turpis. Sed congue est semper ligula posuere, quis fermentum lectus lobortis. Etiam quam\n    elit, vehicula vitae orci ac, aliquam venenatis orci. Ut accumsan tincidunt luctus.</p>\n  <br>\n</div>\n<div class="col-md-4"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/iqnybdlsju.webp?v=1673517351&width=700"></div>\n<div class="col-md-8">\n<h3>Aliquam erat & <br> volutpat porttitor</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia\n  nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat\n  mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat\n  facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis\n  scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum\n  pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida,\n  at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut\n  ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis\n  molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n<br>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia\n    nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat\n    mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat\n    facilisis. Proin nec consectetur enim.</p>\n</div>\n</div>',
        images: [
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497409098048,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497409130816,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25a.jpg?v=1675938837',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25a.jpg?v=1675938837',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25a.jpg?v=1675938837',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497409163584,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25b.jpg?v=1675938837',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25b.jpg?v=1675938837',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25b.jpg?v=1675938837',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497409196352,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25c.jpg?v=1675938837',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25c.jpg?v=1675938837',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25c.jpg?v=1675938837',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497409229120,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25d.jpg?v=1675938837',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25d.jpg?v=1675938837',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25d.jpg?v=1675938837',
            attached_to_variant: false,
          },
        ],
        featured_image: {
          created_at: 'Fri Mar 10 10:09:07 UTC 2023',
          updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
          aspect_ratio: 0.8,
          id: 40497409098048,
          media_type: 'image',
          preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
          src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
          width: 1300,
          height: 1625,
          url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
          attached_to_variant: false,
        },
        media: [
          {
            alt: '',
            id: 32852878950720,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852878950720,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852878983488,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852878983488,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25a.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25a.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25a.jpg?v=1675938837',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852879016256,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852879016256,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25b.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25b.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25b.jpg?v=1675938837',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852879049024,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852879049024,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25c.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25c.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25c.jpg?v=1675938837',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852879081792,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852879081792,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25d.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25d.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25d.jpg?v=1675938837',
              alt: '',
              attached_to_variant: false,
            },
          },
        ],
        options: ['Color', 'Size'],
        price_max: 999,
        price_min: 999,
        price_varies: false,
        published_at: '2023-02-09T10:33:50Z',
        created_at: '2023-02-09T10:33:57Z',
        type: 'Hat',
        tags: ['Sunglasses'],
        variants: [
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497409098048,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              attached_to_variant: false,
              variant_ids: ['44417607926080'],
            },
            barcode: '',
            compare_at_price: 2999,
            id: 44417607926080,
            inventory_management: 'NOT_MANAGED',
            options: ['Sienna', 'M'],
            price: 999,
            requires_shipping: true,
            sku: 'Rev_114',
            title: 'Sienna / M',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497409098048,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              attached_to_variant: false,
              variant_ids: ['44417607926080'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497409098048,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              attached_to_variant: false,
              variant_ids: ['44417607958848'],
            },
            barcode: '',
            compare_at_price: 2999,
            id: 44417607958848,
            inventory_management: 'NOT_MANAGED',
            options: ['Black', 'M'],
            price: 999,
            requires_shipping: true,
            sku: '',
            title: 'Black / M',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497409098048,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              attached_to_variant: false,
              variant_ids: ['44417607958848'],
            },
            inventory_quantity: 0,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497409098048,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              attached_to_variant: false,
              variant_ids: ['44417607991616'],
            },
            barcode: '',
            compare_at_price: 2999,
            id: 44417607991616,
            inventory_management: 'NOT_MANAGED',
            options: ['Chartreuse', 'XS'],
            price: 999,
            requires_shipping: true,
            sku: '',
            title: 'Chartreuse / XS',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497409098048,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              attached_to_variant: false,
              variant_ids: ['44417607991616'],
            },
            inventory_quantity: 0,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497409098048,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              attached_to_variant: false,
              variant_ids: ['44417608024384'],
            },
            barcode: '',
            compare_at_price: 2999,
            id: 44417608024384,
            inventory_management: 'NOT_MANAGED',
            options: ['Gold', 'M'],
            price: 999,
            requires_shipping: true,
            sku: '',
            title: 'Gold / M',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497409098048,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              attached_to_variant: false,
              variant_ids: ['44417608024384'],
            },
            inventory_quantity: 0,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497409098048,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              attached_to_variant: false,
              variant_ids: ['44417608057152'],
            },
            barcode: '',
            compare_at_price: 2999,
            id: 44417608057152,
            inventory_management: 'NOT_MANAGED',
            options: ['Blue Violet', 'XL'],
            price: 999,
            requires_shipping: true,
            sku: '',
            title: 'Blue Violet / XL',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:09:07 UTC 2023',
              updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497409098048,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
              attached_to_variant: false,
              variant_ids: ['44417608057152'],
            },
            inventory_quantity: 0,
          },
        ],
        options_with_values: [
          {
            name: 'Color',
            position: 1,
            values: ['Sienna', 'Black', 'Chartreuse', 'Gold', 'Blue Violet'],
            selected_value: 'Sienna',
          },
          {
            name: 'Size',
            position: 2,
            values: ['M', 'XS', 'XL'],
            selected_value: 'M',
          },
        ],
        first_available_variant: {
          image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497409098048,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            attached_to_variant: false,
            variant_ids: ['44417607926080'],
          },
          barcode: '',
          compare_at_price: 2999,
          id: 44417607926080,
          inventory_management: 'NOT_MANAGED',
          options: ['Sienna', 'M'],
          price: 999,
          requires_shipping: true,
          sku: 'Rev_114',
          title: 'Sienna / M',
          weight: 0,
          available: true,
          featured_image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497409098048,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            attached_to_variant: false,
            variant_ids: ['44417607926080'],
          },
          inventory_quantity: 1,
        },
        selected_or_first_available_variant: {
          image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: null,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            attached_to_variant: false,
            variant_ids: ['44417607926080'],
          },
          barcode: '',
          compare_at_price: 2999,
          id: 44417607926080,
          inventory_management: 'NOT_MANAGED',
          options: ['Sienna', 'M'],
          price: 999,
          requires_shipping: true,
          sku: 'Rev_114',
          title: 'Sienna / M',
          weight: 0,
          available: true,
          featured_image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497409098048,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            attached_to_variant: false,
            variant_ids: ['44417607926080'],
          },
          inventory_quantity: 1,
        },
        featured_media: {
          alt: '',
          id: 32852878950720,
          position: 'IMAGE',
          preview_image: {
            created_at: 'Fri Mar 10 10:09:07 UTC 2023',
            updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
            aspect_ratio: 0.8,
            id: 32852878950720,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-25.jpg?v=1675938837',
            alt: '',
            attached_to_variant: false,
          },
        },
        has_only_default_variant: false,
        collections: [],
        selected_variant: null,
      },
      {
        object_type: 'product',
        id: 8140610765120,
        gift_card: true,
        price: 10000,
        title: 'Washed-effect linen long-sleeved shirt',
        url: '/products/straw-hat-with-grosgrain-band-2',
        vendor: 'Wiloke Store',
        handle: 'straw-hat-with-grosgrain-band-2',
        available: true,
        compare_at_price: 12000,
        compare_at_price_max: 12000,
        compare_at_price_min: 12000,
        compare_at_price_varies: false,
        content:
          '<div class="row">\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/cesimuvwzt.jpg?v=1673582225&width=500"></div>\n<div class="col-md-7">\n<h3>Aliquam erat & <br> volutpat porttitor</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n<div class="col-xs-12">\n<br>\n<h3>Maecenas in orci sollicitudin</h3>\n<p>Praesent euismod eu quam at pretium. Aenean vestibulum malesuada magna a blandit. Maecenas vitae congue mi. Vestibulum placerat, velit vitae eleifend efficitur, eros dolor pulvinar nibh, sed faucibus neque libero vitae purus. Praesent tincidunt nibh vitae neque congue, vulputate tincidunt velit efficitur. Cras tempor, erat in ornare pharetra, purus metus scelerisque ipsum, a sollicitudin urna velit in arcu. Nulla non nunc congue ante euismod hendrerit. Donec eu tellus eu sem vulputate scelerisque nec ut ligula. Maecenas in orci sollicitudin, suscipit enim eu, dictum turpis. Sed congue est semper ligula posuere, quis fermentum lectus lobortis. Etiam quam elit, vehicula vitae orci ac, aliquam venenatis orci. Ut accumsan tincidunt luctus.</p>\n<br>\n</div>\n<div class="col-md-7">\n<h3>Donec eu tellus eu sem vulputate</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/asojvfsedf.png?v=1673948044&width=500"></div>\n</div>',
        description:
          '<div class="row">\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/cesimuvwzt.jpg?v=1673582225&width=500"></div>\n<div class="col-md-7">\n<h3>Aliquam erat & <br> volutpat porttitor</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n<div class="col-xs-12">\n<br>\n<h3>Maecenas in orci sollicitudin</h3>\n<p>Praesent euismod eu quam at pretium. Aenean vestibulum malesuada magna a blandit. Maecenas vitae congue mi. Vestibulum placerat, velit vitae eleifend efficitur, eros dolor pulvinar nibh, sed faucibus neque libero vitae purus. Praesent tincidunt nibh vitae neque congue, vulputate tincidunt velit efficitur. Cras tempor, erat in ornare pharetra, purus metus scelerisque ipsum, a sollicitudin urna velit in arcu. Nulla non nunc congue ante euismod hendrerit. Donec eu tellus eu sem vulputate scelerisque nec ut ligula. Maecenas in orci sollicitudin, suscipit enim eu, dictum turpis. Sed congue est semper ligula posuere, quis fermentum lectus lobortis. Etiam quam elit, vehicula vitae orci ac, aliquam venenatis orci. Ut accumsan tincidunt luctus.</p>\n<br>\n</div>\n<div class="col-md-7">\n<h3>Donec eu tellus eu sem vulputate</h3>\n<p>Praesent varius pellentesque massa ac iaculis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras mollis lorem lorem, vel posuere justo porttitor vitae. Nunc vel metus et erat mollis lobortis non ut nisi. Aliquam erat volutpat. Cras interdum convallis dapibus. Sed porta nulla in consequat facilisis. Proin nec consectetur enim.</p>\n<p>Aenean mauris lacus, tincidunt vitae sapien in, porttitor blandit nisl. Morbi vel risus vel sem venenatis scelerisque. Duis orci elit, dictum nec elit vitae, accumsan egestas libero. Vivamus et dolor at nisi vestibulum pulvinar. Fusce semper ex vel nibh porttitor, a pellentesque sem molestie. Aliquam posuere neque eu augue gravida, at faucibus nibh fermentum. Sed vehicula neque non nibh imperdiet, non bibendum est imperdiet. Maecenas ut ultrices nibh, a eleifend dolor. Aenean convallis ipsum et erat gravida, lobortis semper eros viverra. Duis molestie rhoncus fringilla. Pellentesque sit amet nisi nulla.</p>\n</div>\n<div class="col-md-5"><img alt="" src="//cdn.shopify.com/s/files/1/0552/5510/5616/files/asojvfsedf.png?v=1673948044&width=500"></div>\n</div>',
        images: [
          {
            created_at: 'Fri Mar 10 10:10:19 UTC 2023',
            updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497410343232,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:10:19 UTC 2023',
            updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497410408768,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:10:19 UTC 2023',
            updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497410441536,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:10:19 UTC 2023',
            updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497410474304,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8c.jpg?v=1675938845',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8c.jpg?v=1675938845',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8c.jpg?v=1675938845',
            attached_to_variant: false,
          },
          {
            created_at: 'Fri Mar 10 10:10:19 UTC 2023',
            updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497410507072,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8d.jpg?v=1675938845',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8d.jpg?v=1675938845',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8d.jpg?v=1675938845',
            attached_to_variant: false,
          },
        ],
        featured_image: {
          created_at: 'Fri Mar 10 10:10:19 UTC 2023',
          updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
          aspect_ratio: 0.8,
          id: 40497410343232,
          media_type: 'image',
          preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
          src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
          width: 1300,
          height: 1625,
          url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
          attached_to_variant: false,
        },
        media: [
          {
            alt: '',
            id: 32852880228672,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852880228672,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852880294208,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852880294208,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852880326976,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852880326976,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852880359744,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852880359744,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8c.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8c.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8c.jpg?v=1675938845',
              alt: '',
              attached_to_variant: false,
            },
          },
          {
            alt: '',
            id: 32852880392512,
            position: 'IMAGE',
            preview_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 32852880392512,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8d.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8d.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8d.jpg?v=1675938845',
              alt: '',
              attached_to_variant: false,
            },
          },
        ],
        options: ['Color', 'Size'],
        price_max: 10000,
        price_min: 10000,
        price_varies: false,
        published_at: '2023-02-09T10:33:58Z',
        created_at: '2023-02-09T10:34:04Z',
        type: 'Hat',
        tags: ['Hats', 'Wiloke'],
        variants: [
          {
            image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410408768,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
              attached_to_variant: false,
            },
            barcode: '',
            compare_at_price: 12000,
            id: 44417608286528,
            inventory_management: 'NOT_MANAGED',
            options: ['Black', 'S'],
            price: 10000,
            requires_shipping: true,
            sku: 'Rev_142',
            title: 'Black / S',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410408768,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
              attached_to_variant: false,
              variant_ids: ['44417608286528'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410441536,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              attached_to_variant: false,
            },
            barcode: '',
            compare_at_price: 12000,
            id: 44417608319296,
            inventory_management: 'NOT_MANAGED',
            options: ['Black', 'M'],
            price: 10000,
            requires_shipping: true,
            sku: '',
            title: 'Black / M',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410441536,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              attached_to_variant: false,
              variant_ids: ['44417608319296'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
            },
            barcode: '',
            compare_at_price: 12000,
            id: 44417608352064,
            inventory_management: 'NOT_MANAGED',
            options: ['Black', 'L'],
            price: 10000,
            requires_shipping: true,
            sku: '',
            title: 'Black / L',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
              variant_ids: ['44417608352064'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
            },
            barcode: '',
            compare_at_price: 12000,
            id: 44417608384832,
            inventory_management: 'NOT_MANAGED',
            options: ['Black', 'XL'],
            price: 10000,
            requires_shipping: true,
            sku: '',
            title: 'Black / XL',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
              variant_ids: ['44417608384832'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
            },
            barcode: '',
            compare_at_price: 12000,
            id: 44417608417600,
            inventory_management: 'NOT_MANAGED',
            options: ['Black', 'XXL'],
            price: 10000,
            requires_shipping: true,
            sku: '',
            title: 'Black / XXL',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
              variant_ids: ['44417608417600'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410441536,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              attached_to_variant: false,
            },
            barcode: '',
            compare_at_price: 12000,
            id: 44417608450368,
            inventory_management: 'NOT_MANAGED',
            options: ['Red', 'S'],
            price: 10000,
            requires_shipping: true,
            sku: 'Rev_143',
            title: 'Red / S',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410441536,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8b.jpg?v=1675938845',
              attached_to_variant: false,
              variant_ids: ['44417608450368'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
            },
            barcode: '',
            compare_at_price: 12000,
            id: 44417608483136,
            inventory_management: 'NOT_MANAGED',
            options: ['Red', 'M'],
            price: 10000,
            requires_shipping: true,
            sku: '',
            title: 'Red / M',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
              variant_ids: ['44417608483136'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
            },
            barcode: '',
            compare_at_price: 12000,
            id: 44417608515904,
            inventory_management: 'NOT_MANAGED',
            options: ['Red', 'L'],
            price: 10000,
            requires_shipping: true,
            sku: '',
            title: 'Red / L',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
              variant_ids: ['44417608515904'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
            },
            barcode: '',
            compare_at_price: 12000,
            id: 44417608548672,
            inventory_management: 'NOT_MANAGED',
            options: ['Red', 'XL'],
            price: 10000,
            requires_shipping: true,
            sku: '',
            title: 'Red / XL',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
              variant_ids: ['44417608548672'],
            },
            inventory_quantity: 1,
          },
          {
            image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
            },
            barcode: '',
            compare_at_price: 12000,
            id: 44417608581440,
            inventory_management: 'NOT_MANAGED',
            options: ['Red', 'XXL'],
            price: 10000,
            requires_shipping: true,
            sku: '',
            title: 'Red / XXL',
            weight: 0,
            available: true,
            featured_image: {
              created_at: 'Fri Mar 10 10:10:19 UTC 2023',
              updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
              aspect_ratio: 0.8,
              id: 40497410343232,
              media_type: 'image',
              preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              width: 1300,
              height: 1625,
              url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
              attached_to_variant: false,
              variant_ids: ['44417608581440'],
            },
            inventory_quantity: 1,
          },
        ],
        options_with_values: [
          {
            name: 'Color',
            position: 1,
            values: ['Black', 'Red'],
            selected_value: 'Black',
          },
          {
            name: 'Size',
            position: 2,
            values: ['S', 'M', 'L', 'XL', 'XXL'],
            selected_value: 'S',
          },
        ],
        first_available_variant: {
          image: {
            created_at: 'Fri Mar 10 10:10:19 UTC 2023',
            updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497410408768,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            attached_to_variant: false,
            variant_ids: ['44417608286528'],
          },
          barcode: '',
          compare_at_price: 12000,
          id: 44417608286528,
          inventory_management: 'NOT_MANAGED',
          options: ['Black', 'S'],
          price: 10000,
          requires_shipping: true,
          sku: 'Rev_142',
          title: 'Black / S',
          weight: 0,
          available: true,
          featured_image: {
            created_at: 'Fri Mar 10 10:10:19 UTC 2023',
            updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497410408768,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            attached_to_variant: false,
            variant_ids: ['44417608286528'],
          },
          inventory_quantity: 1,
        },
        selected_or_first_available_variant: {
          image: {
            created_at: 'Fri Mar 10 10:10:19 UTC 2023',
            updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
            aspect_ratio: 0.8,
            id: null,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            attached_to_variant: false,
            variant_ids: ['44417608286528'],
          },
          barcode: '',
          compare_at_price: 12000,
          id: 44417608286528,
          inventory_management: 'NOT_MANAGED',
          options: ['Black', 'S'],
          price: 10000,
          requires_shipping: true,
          sku: 'Rev_142',
          title: 'Black / S',
          weight: 0,
          available: true,
          featured_image: {
            created_at: 'Fri Mar 10 10:10:19 UTC 2023',
            updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
            aspect_ratio: 0.8,
            id: 40497410408768,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8a.jpg?v=1675938845',
            attached_to_variant: false,
            variant_ids: ['44417608286528'],
          },
          inventory_quantity: 1,
        },
        featured_media: {
          alt: '',
          id: 32852880228672,
          position: 'IMAGE',
          preview_image: {
            created_at: 'Fri Mar 10 10:10:19 UTC 2023',
            updated_at: 'Fri Mar 10 10:10:19 UTC 2023',
            aspect_ratio: 0.8,
            id: 32852880228672,
            media_type: 'image',
            preview_image: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
            src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
            width: 1300,
            height: 1625,
            url: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/products/Product-8.jpg?v=1675938845',
            alt: '',
            attached_to_variant: false,
          },
        },
        has_only_default_variant: false,
        collections: [],
        selected_variant: null,
      },
      {
        object_type: 'article',
        body_html:
          '<p>Fashion is an ever-evolving industry that has the power to inspire and impact the world in many ways. From setting trends to creating self-expression, fashion has become a major aspect of modern society.</p>\n<blockquote>\n<p>Fashion is not something that exists in dresses only. Fashion is in the sky, in the street, fashion has to do with ideas, the way we live, what is happening. - Coco Chanel</p>\n</blockquote>\n<h2></h2>\n<h4>The History of Fashion</h4>\n<p>Fashion has been around for centuries, dating back to the early civilizations of Egypt, Greece, and Rome. During these times, fashion was used as a way to show wealth and status, with the ruling classes wearing the finest garments and adornments. Over time, fashion has continued to change and evolve, with new styles and designs emerging each decade.<br><br>One of the biggest turning points in fashion history was the introduction of haute couture in the 19th century. Haute couture, meaning “high sewing” in French, was a new way of designing and creating high-end, made-to-measure clothing for the elite. Today, haute couture is still considered the epitome of luxury fashion, with many top designers showcasing their collections each season.</p>\n<p> </p>\n<div style="text-align: left;"><img src="https://cdn.shopify.com/s/files/1/0718/9312/3392/files/1000x350_480x480.png?v=1675678329" alt="women-dress" style="float: none; display: block; margin-left: auto; margin-right: auto;"></div>\n<h2></h2>\n<h4></h4>\n<h4></h4>\n<h4>The Impact of Fashion on Society</h4>\n<p>Fashion has the power to shape and influence society in many ways. Moreover, fashion can also bring about cultural and political change.</p>\n<ul>\n<li>For example, during the 1960s, the youth culture of the time used fashion as a form of self-expression and rebellion against traditional societal norms.</li>\n<li>The women’s rights movement of the late 19th and early 20th centuries, for example, was reflected in the changing styles of women’s clothing.</li>\n</ul>\n<h2></h2>\n<h4>The Future of Fashion</h4>\n<p>The future of fashion looks bright, with new technologies and materials continuously being introduced and integrated into the industry. For example, sustainable and eco-friendly materials, such as organic cotton and recycled polyester, are becoming increasingly popular as consumers become more conscious of their impact on the environment.<br><br>Additionally, the rise of digital technology has had a profound impact on the fashion industry, with virtual try-on technology, augmented reality shopping experiences, and the increasing use of social media platforms to showcase collections and connect with consumers.</p>\n<p> </p>\n<p><em><strong>Table: The Evolution of Fashion</strong></em></p>\n<table style="width: 97.4563%;">\n<tbody>\n<tr>\n<td style="width: 21.1923%; text-align: left;">Era</td>\n<td style="width: 36.8077%; text-align: left;">Key Styles</td>\n<td style="width: 126%; text-align: left;">Iconic Designers</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1920s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Flapper Dress, Drop Waist</td>\n<td style="width: 126%; text-align: left;">Coco Chanel, Jean Patou</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1960s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Mod, Mini Skirt</td>\n<td style="width: 126%; text-align: left;">Mary Quant, André Courrèges</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1980s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Power Dressing, Shoulder Pads</td>\n<td style="width: 126%; text-align: left;">Giorgio Armani, Donna Karan</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p> 2000s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">\n<p>Low-Rise Jeans, Juicy Couture Tracksuits</p>\n</td>\n<td style="width: 126%; text-align: left;">\n<p>Tom Ford, Alexander McQueen</p>\n</td>\n</tr>\n</tbody>\n</table>',
        blog_id: 94199513408,
        user_id: 91814461760,
        summary_html:
          'Stay ahead of the fashion game with our in-depth coverage of the latest trends, designers, and cultural influences shaping the industry.',
        template_suffix: '',
        comments_count: 0,
        comments_enabled: true,
        author: 'NGUYEN NGUYEN',
        created_at: '2023-02-06T21:45:04-05:00',
        handle: 'fashion-forward-the-future-of-style',
        id: 604851896640,
        image: {
          created_at: 'Fri Mar 10 10:09:07 UTC 2023',
          updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
          aspect_ratio: 1.776199,
          media_type: 'image',
          src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/articles/1800x1000.png?v=1677493900',
          width: 2000,
          height: 1126,
          attached_to_variant: false,
        },
        published_at: '2023-02-06T21:45:04-05:00',
        tags: ['Fashion & Society', 'summer', 'Tech in Fashion'],
        title: 'The Future of Fashion Style',
        updated_at: '2023-02-27T05:31:40-05:00',
        content:
          '<p>Fashion is an ever-evolving industry that has the power to inspire and impact the world in many ways. From setting trends to creating self-expression, fashion has become a major aspect of modern society.</p>\n<blockquote>\n<p>Fashion is not something that exists in dresses only. Fashion is in the sky, in the street, fashion has to do with ideas, the way we live, what is happening. - Coco Chanel</p>\n</blockquote>\n<h2></h2>\n<h4>The History of Fashion</h4>\n<p>Fashion has been around for centuries, dating back to the early civilizations of Egypt, Greece, and Rome. During these times, fashion was used as a way to show wealth and status, with the ruling classes wearing the finest garments and adornments. Over time, fashion has continued to change and evolve, with new styles and designs emerging each decade.<br><br>One of the biggest turning points in fashion history was the introduction of haute couture in the 19th century. Haute couture, meaning “high sewing” in French, was a new way of designing and creating high-end, made-to-measure clothing for the elite. Today, haute couture is still considered the epitome of luxury fashion, with many top designers showcasing their collections each season.</p>\n<p> </p>\n<div style="text-align: left;"><img src="https://cdn.shopify.com/s/files/1/0718/9312/3392/files/1000x350_480x480.png?v=1675678329" alt="women-dress" style="float: none; display: block; margin-left: auto; margin-right: auto;"></div>\n<h2></h2>\n<h4></h4>\n<h4></h4>\n<h4>The Impact of Fashion on Society</h4>\n<p>Fashion has the power to shape and influence society in many ways. Moreover, fashion can also bring about cultural and political change.</p>\n<ul>\n<li>For example, during the 1960s, the youth culture of the time used fashion as a form of self-expression and rebellion against traditional societal norms.</li>\n<li>The women’s rights movement of the late 19th and early 20th centuries, for example, was reflected in the changing styles of women’s clothing.</li>\n</ul>\n<h2></h2>\n<h4>The Future of Fashion</h4>\n<p>The future of fashion looks bright, with new technologies and materials continuously being introduced and integrated into the industry. For example, sustainable and eco-friendly materials, such as organic cotton and recycled polyester, are becoming increasingly popular as consumers become more conscious of their impact on the environment.<br><br>Additionally, the rise of digital technology has had a profound impact on the fashion industry, with virtual try-on technology, augmented reality shopping experiences, and the increasing use of social media platforms to showcase collections and connect with consumers.</p>\n<p> </p>\n<p><em><strong>Table: The Evolution of Fashion</strong></em></p>\n<table style="width: 97.4563%;">\n<tbody>\n<tr>\n<td style="width: 21.1923%; text-align: left;">Era</td>\n<td style="width: 36.8077%; text-align: left;">Key Styles</td>\n<td style="width: 126%; text-align: left;">Iconic Designers</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1920s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Flapper Dress, Drop Waist</td>\n<td style="width: 126%; text-align: left;">Coco Chanel, Jean Patou</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1960s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Mod, Mini Skirt</td>\n<td style="width: 126%; text-align: left;">Mary Quant, André Courrèges</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1980s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Power Dressing, Shoulder Pads</td>\n<td style="width: 126%; text-align: left;">Giorgio Armani, Donna Karan</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p> 2000s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">\n<p>Low-Rise Jeans, Juicy Couture Tracksuits</p>\n</td>\n<td style="width: 126%; text-align: left;">\n<p>Tom Ford, Alexander McQueen</p>\n</td>\n</tr>\n</tbody>\n</table>',
      },
      {
        object_type: 'article',
        body_html:
          '<p>Fashion is an ever-evolving industry that has the power to inspire and impact the world in many ways. From setting trends to creating self-expression, fashion has become a major aspect of modern society.</p>\n<blockquote>\n<p>Fashion is not something that exists in dresses only. Fashion is in the sky, in the street, fashion has to do with ideas, the way we live, what is happening. - Coco Chanel</p>\n</blockquote>\n<h2></h2>\n<h4>The History of Fashion</h4>\n<p>Fashion has been around for centuries, dating back to the early civilizations of Egypt, Greece, and Rome. During these times, fashion was used as a way to show wealth and status, with the ruling classes wearing the finest garments and adornments. Over time, fashion has continued to change and evolve, with new styles and designs emerging each decade.<br><br>One of the biggest turning points in fashion history was the introduction of haute couture in the 19th century. Haute couture, meaning “high sewing” in French, was a new way of designing and creating high-end, made-to-measure clothing for the elite. Today, haute couture is still considered the epitome of luxury fashion, with many top designers showcasing their collections each season.</p>\n<p> </p>\n<div style="text-align: left;"><img src="https://cdn.shopify.com/s/files/1/0718/9312/3392/files/1000x350_480x480.png?v=1675678329" alt="women-dress" style="float: none; display: block; margin-left: auto; margin-right: auto;"></div>\n<h2></h2>\n<h4></h4>\n<h4></h4>\n<h4>The Impact of Fashion on Society</h4>\n<p>Fashion has the power to shape and influence society in many ways. Moreover, fashion can also bring about cultural and political change.</p>\n<ul>\n<li>For example, during the 1960s, the youth culture of the time used fashion as a form of self-expression and rebellion against traditional societal norms.</li>\n<li>The women’s rights movement of the late 19th and early 20th centuries, for example, was reflected in the changing styles of women’s clothing.</li>\n</ul>\n<h2></h2>\n<h4>The Future of Fashion</h4>\n<p>The future of fashion looks bright, with new technologies and materials continuously being introduced and integrated into the industry. For example, sustainable and eco-friendly materials, such as organic cotton and recycled polyester, are becoming increasingly popular as consumers become more conscious of their impact on the environment.<br><br>Additionally, the rise of digital technology has had a profound impact on the fashion industry, with virtual try-on technology, augmented reality shopping experiences, and the increasing use of social media platforms to showcase collections and connect with consumers.</p>\n<p> </p>\n<p><em><strong>Table: The Evolution of Fashion</strong></em></p>\n<table style="width: 97.4563%;">\n<tbody>\n<tr>\n<td style="width: 21.1923%; text-align: left;">Era</td>\n<td style="width: 36.8077%; text-align: left;">Key Styles</td>\n<td style="width: 126%; text-align: left;">Iconic Designers</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1920s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Flapper Dress, Drop Waist</td>\n<td style="width: 126%; text-align: left;">Coco Chanel, Jean Patou</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1960s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Mod, Mini Skirt</td>\n<td style="width: 126%; text-align: left;">Mary Quant, André Courrèges</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1980s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Power Dressing, Shoulder Pads</td>\n<td style="width: 126%; text-align: left;">Giorgio Armani, Donna Karan</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p> 2000s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">\n<p>Low-Rise Jeans, Juicy Couture Tracksuits</p>\n</td>\n<td style="width: 126%; text-align: left;">\n<p>Tom Ford, Alexander McQueen</p>\n</td>\n</tr>\n</tbody>\n</table>',
        blog_id: 94199513408,
        user_id: 91814461760,
        summary_html:
          "<ol>\n<li>Discover the rich history of fashion and explore its evolution over time, from the iconic styles of past decades to today's cutting-edge designs.</li>\n</ol>",
        template_suffix: '',
        comments_count: 0,
        comments_enabled: true,
        author: 'NGUYEN NGUYEN',
        created_at: '2023-02-06T21:45:52-05:00',
        handle: 'the-power-of-fashion-societys-impact',
        id: 604851929408,
        image: {
          created_at: 'Fri Mar 10 10:09:07 UTC 2023',
          updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
          aspect_ratio: 1.776199,
          media_type: 'image',
          src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/articles/18acdsad00x1000-1.png?v=1677493783',
          width: 2000,
          height: 1126,
          attached_to_variant: false,
        },
        published_at: '2023-02-06T21:45:52-05:00',
        tags: ['fashion history', 'summer', 'Trending Styles'],
        title: 'The Society Power of Fashion',
        updated_at: '2023-02-27T05:29:43-05:00',
        content:
          '<p>Fashion is an ever-evolving industry that has the power to inspire and impact the world in many ways. From setting trends to creating self-expression, fashion has become a major aspect of modern society.</p>\n<blockquote>\n<p>Fashion is not something that exists in dresses only. Fashion is in the sky, in the street, fashion has to do with ideas, the way we live, what is happening. - Coco Chanel</p>\n</blockquote>\n<h2></h2>\n<h4>The History of Fashion</h4>\n<p>Fashion has been around for centuries, dating back to the early civilizations of Egypt, Greece, and Rome. During these times, fashion was used as a way to show wealth and status, with the ruling classes wearing the finest garments and adornments. Over time, fashion has continued to change and evolve, with new styles and designs emerging each decade.<br><br>One of the biggest turning points in fashion history was the introduction of haute couture in the 19th century. Haute couture, meaning “high sewing” in French, was a new way of designing and creating high-end, made-to-measure clothing for the elite. Today, haute couture is still considered the epitome of luxury fashion, with many top designers showcasing their collections each season.</p>\n<p> </p>\n<div style="text-align: left;"><img src="https://cdn.shopify.com/s/files/1/0718/9312/3392/files/1000x350_480x480.png?v=1675678329" alt="women-dress" style="float: none; display: block; margin-left: auto; margin-right: auto;"></div>\n<h2></h2>\n<h4></h4>\n<h4></h4>\n<h4>The Impact of Fashion on Society</h4>\n<p>Fashion has the power to shape and influence society in many ways. Moreover, fashion can also bring about cultural and political change.</p>\n<ul>\n<li>For example, during the 1960s, the youth culture of the time used fashion as a form of self-expression and rebellion against traditional societal norms.</li>\n<li>The women’s rights movement of the late 19th and early 20th centuries, for example, was reflected in the changing styles of women’s clothing.</li>\n</ul>\n<h2></h2>\n<h4>The Future of Fashion</h4>\n<p>The future of fashion looks bright, with new technologies and materials continuously being introduced and integrated into the industry. For example, sustainable and eco-friendly materials, such as organic cotton and recycled polyester, are becoming increasingly popular as consumers become more conscious of their impact on the environment.<br><br>Additionally, the rise of digital technology has had a profound impact on the fashion industry, with virtual try-on technology, augmented reality shopping experiences, and the increasing use of social media platforms to showcase collections and connect with consumers.</p>\n<p> </p>\n<p><em><strong>Table: The Evolution of Fashion</strong></em></p>\n<table style="width: 97.4563%;">\n<tbody>\n<tr>\n<td style="width: 21.1923%; text-align: left;">Era</td>\n<td style="width: 36.8077%; text-align: left;">Key Styles</td>\n<td style="width: 126%; text-align: left;">Iconic Designers</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1920s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Flapper Dress, Drop Waist</td>\n<td style="width: 126%; text-align: left;">Coco Chanel, Jean Patou</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1960s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Mod, Mini Skirt</td>\n<td style="width: 126%; text-align: left;">Mary Quant, André Courrèges</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1980s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Power Dressing, Shoulder Pads</td>\n<td style="width: 126%; text-align: left;">Giorgio Armani, Donna Karan</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p> 2000s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">\n<p>Low-Rise Jeans, Juicy Couture Tracksuits</p>\n</td>\n<td style="width: 126%; text-align: left;">\n<p>Tom Ford, Alexander McQueen</p>\n</td>\n</tr>\n</tbody>\n</table>',
      },
      {
        object_type: 'article',
        body_html:
          '<p>Fashion is an ever-evolving industry that has the power to inspire and impact the world in many ways. From setting trends to creating self-expression, fashion has become a major aspect of modern society.</p>\n<blockquote>\n<p>Fashion is not something that exists in dresses only. Fashion is in the sky, in the street, fashion has to do with ideas, the way we live, what is happening. - Coco Chanel</p>\n</blockquote>\n<h2></h2>\n<h4>The History of Fashion</h4>\n<p>Fashion has been around for centuries, dating back to the early civilizations of Egypt, Greece, and Rome. During these times, fashion was used as a way to show wealth and status, with the ruling classes wearing the finest garments and adornments. Over time, fashion has continued to change and evolve, with new styles and designs emerging each decade.<br><br>One of the biggest turning points in fashion history was the introduction of haute couture in the 19th century. Haute couture, meaning “high sewing” in French, was a new way of designing and creating high-end, made-to-measure clothing for the elite. Today, haute couture is still considered the epitome of luxury fashion, with many top designers showcasing their collections each season.</p>\n<p> </p>\n<div style="text-align: left;"><img src="https://cdn.shopify.com/s/files/1/0718/9312/3392/files/1000x350_480x480.png?v=1675678329" alt="women-dress" style="float: none; display: block; margin-left: auto; margin-right: auto;"></div>\n<h2></h2>\n<h4></h4>\n<h4></h4>\n<h4>The Impact of Fashion on Society</h4>\n<p>Fashion has the power to shape and influence society in many ways. Moreover, fashion can also bring about cultural and political change.</p>\n<ul>\n<li>For example, during the 1960s, the youth culture of the time used fashion as a form of self-expression and rebellion against traditional societal norms.</li>\n<li>The women’s rights movement of the late 19th and early 20th centuries, for example, was reflected in the changing styles of women’s clothing.</li>\n</ul>\n<h2></h2>\n<h4>The Future of Fashion</h4>\n<p>The future of fashion looks bright, with new technologies and materials continuously being introduced and integrated into the industry. For example, sustainable and eco-friendly materials, such as organic cotton and recycled polyester, are becoming increasingly popular as consumers become more conscious of their impact on the environment.<br><br>Additionally, the rise of digital technology has had a profound impact on the fashion industry, with virtual try-on technology, augmented reality shopping experiences, and the increasing use of social media platforms to showcase collections and connect with consumers.</p>\n<p> </p>\n<p><em><strong>Table: The Evolution of Fashion</strong></em></p>\n<table style="width: 97.4563%;">\n<tbody>\n<tr>\n<td style="width: 21.1923%; text-align: left;">Era</td>\n<td style="width: 36.8077%; text-align: left;">Key Styles</td>\n<td style="width: 126%; text-align: left;">Iconic Designers</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1920s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Flapper Dress, Drop Waist</td>\n<td style="width: 126%; text-align: left;">Coco Chanel, Jean Patou</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1960s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Mod, Mini Skirt</td>\n<td style="width: 126%; text-align: left;">Mary Quant, André Courrèges</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1980s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Power Dressing, Shoulder Pads</td>\n<td style="width: 126%; text-align: left;">Giorgio Armani, Donna Karan</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p> 2000s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">\n<p>Low-Rise Jeans, Juicy Couture Tracksuits</p>\n</td>\n<td style="width: 126%; text-align: left;">\n<p>Tom Ford, Alexander McQueen</p>\n</td>\n</tr>\n</tbody>\n</table>',
        blog_id: 94199513408,
        user_id: 91814461760,
        summary_html:
          '<span>This blog post explores the rich history of fashion and its impact on society. From the haute couture of the 19th century to the sustainable and digital future of fashion, we take a look at the evolution of style and the key designers who have shaped the industry.</span>',
        template_suffix: '',
        comments_count: 0,
        comments_enabled: true,
        author: 'NGUYEN NGUYEN',
        created_at: '2023-02-06T21:28:10-05:00',
        handle: 'redefining-style-trends-to-watch',
        id: 604851765568,
        image: {
          created_at: 'Fri Mar 10 10:09:07 UTC 2023',
          updated_at: 'Fri Mar 10 10:09:07 UTC 2023',
          aspect_ratio: 1.776199,
          media_type: 'image',
          src: 'https://cdn.shopify.com/s/files/1/0718/9312/3392/articles/18acdsad00x1000.png?v=1677493932',
          width: 2000,
          height: 1126,
          attached_to_variant: false,
        },
        published_at: '2023-02-06T21:28:10-05:00',
        tags: ['collection', 'Fashion & Society', 'Trending Styles'],
        title: 'Trends to Watch Redefining Style',
        updated_at: '2023-03-10T01:57:42-05:00',
        content:
          '<p>Fashion is an ever-evolving industry that has the power to inspire and impact the world in many ways. From setting trends to creating self-expression, fashion has become a major aspect of modern society.</p>\n<blockquote>\n<p>Fashion is not something that exists in dresses only. Fashion is in the sky, in the street, fashion has to do with ideas, the way we live, what is happening. - Coco Chanel</p>\n</blockquote>\n<h2></h2>\n<h4>The History of Fashion</h4>\n<p>Fashion has been around for centuries, dating back to the early civilizations of Egypt, Greece, and Rome. During these times, fashion was used as a way to show wealth and status, with the ruling classes wearing the finest garments and adornments. Over time, fashion has continued to change and evolve, with new styles and designs emerging each decade.<br><br>One of the biggest turning points in fashion history was the introduction of haute couture in the 19th century. Haute couture, meaning “high sewing” in French, was a new way of designing and creating high-end, made-to-measure clothing for the elite. Today, haute couture is still considered the epitome of luxury fashion, with many top designers showcasing their collections each season.</p>\n<p> </p>\n<div style="text-align: left;"><img src="https://cdn.shopify.com/s/files/1/0718/9312/3392/files/1000x350_480x480.png?v=1675678329" alt="women-dress" style="float: none; display: block; margin-left: auto; margin-right: auto;"></div>\n<h2></h2>\n<h4></h4>\n<h4></h4>\n<h4>The Impact of Fashion on Society</h4>\n<p>Fashion has the power to shape and influence society in many ways. Moreover, fashion can also bring about cultural and political change.</p>\n<ul>\n<li>For example, during the 1960s, the youth culture of the time used fashion as a form of self-expression and rebellion against traditional societal norms.</li>\n<li>The women’s rights movement of the late 19th and early 20th centuries, for example, was reflected in the changing styles of women’s clothing.</li>\n</ul>\n<h2></h2>\n<h4>The Future of Fashion</h4>\n<p>The future of fashion looks bright, with new technologies and materials continuously being introduced and integrated into the industry. For example, sustainable and eco-friendly materials, such as organic cotton and recycled polyester, are becoming increasingly popular as consumers become more conscious of their impact on the environment.<br><br>Additionally, the rise of digital technology has had a profound impact on the fashion industry, with virtual try-on technology, augmented reality shopping experiences, and the increasing use of social media platforms to showcase collections and connect with consumers.</p>\n<p> </p>\n<p><em><strong>Table: The Evolution of Fashion</strong></em></p>\n<table style="width: 97.4563%;">\n<tbody>\n<tr>\n<td style="width: 21.1923%; text-align: left;">Era</td>\n<td style="width: 36.8077%; text-align: left;">Key Styles</td>\n<td style="width: 126%; text-align: left;">Iconic Designers</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1920s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Flapper Dress, Drop Waist</td>\n<td style="width: 126%; text-align: left;">Coco Chanel, Jean Patou</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1960s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Mod, Mini Skirt</td>\n<td style="width: 126%; text-align: left;">Mary Quant, André Courrèges</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p>1980s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">Power Dressing, Shoulder Pads</td>\n<td style="width: 126%; text-align: left;">Giorgio Armani, Donna Karan</td>\n</tr>\n<tr>\n<td style="width: 21.1923%; text-align: left;">\n<p> 2000s</p>\n</td>\n<td style="width: 36.8077%; text-align: left;">\n<p>Low-Rise Jeans, Juicy Couture Tracksuits</p>\n</td>\n<td style="width: 126%; text-align: left;">\n<p>Tom Ford, Alexander McQueen</p>\n</td>\n</tr>\n</tbody>\n</table>',
      },
      {
        object_type: 'page',
        author: 'Veda',
        content: '<p>Explore our fashion blog page for inspiring and on-trend fashion content, from outfit ideas to style advice.</p>',
        handle: 'blog',
        id: 83536642113,
        metafields: {},
        published_at: '2023-03-03 17:47:03 -0400',
        template_suffix: '',
        title: 'Blog Page',
        url: '/blog',
      },
      {
        object_type: 'page',
        author: 'Veda',
        content:
          '<p>Reach us easily with our contact page. Fill out our simple form or find our contact information for any questions or concerns you may have.</p>',
        handle: 'contact',
        id: 83536642113,
        metafields: {},
        published_at: '2023-01-04 17:47:03 -0400',
        template_suffix: '',
        title: 'Contact Page',
        url: '/contact',
      },
      {
        object_type: 'page',
        author: 'Veda',
        content: '<p>Stay up to date with the latest fashion news and tips on our informative article page.</p>',
        handle: 'article',
        id: 83536642113,
        metafields: {},
        published_at: '2022-02-02 12:00:00 -0400',
        template_suffix: '',
        title: 'Article Page',
        url: '/article',
      },
    ],
    results_count: 10,
    sort_by: 'relevance',
    sort_options: [
      {
        name: 'Alphabetically, A-Z',
        value: 'title-ascending',
      },
    ],
    terms: 'veda',
    types: ['article', 'page', 'product'],
  };
};
